<template>
  <div class="login-page">
    <TwoFA />
    <main class="login-card" aria-labelledby="login-title">
      <img src="@/assets/mfu_logo.png" alt="MFU Logo" class="login-logo" />

      <h1 id="login-title">Sign in</h1>
      <p class="login-muted">Sign in with MFU Google account</p>

      <div v-if="error" class="error-message">
        {{ error }}
      </div>

      <button
        class="google-signin"
        type="button"
        :disabled="loading"
        :aria-label="loading ? 'Signing in with Google' : 'Sign in with Google'"
        @click="handleGoogleSignIn"
      >
        <span class="google-symbol" aria-hidden="true">{{ loading ? '...' : 'G+' }}</span>
      </button>
    </main>
  </div>
</template>

<script>
import TwoFA from '@/projects/components/dialog/TwoFA.vue'

export default {
  name: 'Login',
  components: {
    TwoFA
  },
  data() {
    return {
      loading: false,
      error: null
    }
  },
  methods: {
    async handleGoogleSignIn() {
      this.error = null
      this.loading = true
      try {
        const googleUser = await this.$gAuth.signIn()
        const authResponse = googleUser && typeof googleUser.getAuthResponse === 'function'
          ? googleUser.getAuthResponse()
          : null
        const idToken = authResponse && authResponse.id_token ? String(authResponse.id_token) : ''

        if (!idToken) {
          throw new Error('Google sign-in did not return an ID token.')
        }

        await this.$store.dispatch('auth/signIn', {
          token: idToken,
          authType: '689c06d5255db4e56aea8902'
        })
      } catch (e) {
        this.error = (e && e.message) ? e.message : 'Google sign-in failed. Please try again.'
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    try {
      const profile = await this.$store.dispatch('auth/bootstrapSession')
      const authState = this.$store.getters['auth/authenticated'] || {}
      if (profile && authState.isAuthen) {
        this.$router.push('/dashboard')
      }
    } catch (e) {
      // keep the user on the login page
    }
  }
}
</script>

<style scoped>
.login-page {
  align-items: center;
  background: #eef0f3;
  box-sizing: border-box;
  color: #1E293B;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 20px;
}

.login-card {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 512px;
  padding: 56px 32px;
  width: min(100%, 880px);
}

.login-logo {
  height: 150px;
  margin-bottom: 22px;
  width: auto;
}

.login-card h1 {
  color: #2f3a4d;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0 0 14px;
  text-align: center;
}

.login-muted {
  color: #7a8798;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 30px;
  text-align: center;
}

.error-message {
  background-color: #f8d7da;
  border-radius: 6px;
  color: #dc3545;
  font-size: 14px;
  margin: -10px 0 20px;
  max-width: 420px;
  padding: 9px 12px;
  text-align: center;
  width: 100%;
}

.google-signin {
  align-items: center;
  background: #d85648;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  height: 72px;
  justify-content: center;
  padding: 0;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  width: 72px;
}

.google-signin:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.google-signin:hover:not(:disabled) {
  background: #cf4e41;
  box-shadow: 0 0 0 4px rgba(216, 86, 72, 0.12);
}

.google-symbol {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
}

@media (max-width: 767.98px) {
  .login-page {
    padding: 20px 14px;
  }

  .login-card {
    min-height: 440px;
    padding: 42px 24px;
  }

  .login-logo {
    height: 128px;
  }

  .google-signin {
    height: 68px;
    width: 68px;
  }
}
</style>
